<div class="outer">
  <div class="content-signin">
    <div class="right-login center-content">
      <div class="container-fluid form-login account-deleted text-center">
        <img src="assets/img/img-deleted-account.svg" alt="delete" />
        <p class="fw-medium text-primary">
          <span i18n="@@account_deleted_confirmation"
            >Votre compte a bien été supprimé</span
          >
        </p>
      </div>
    </div>
  </div>
</div>
